import { render, staticRenderFns } from "./OccupazioneBinari.vue?vue&type=template&id=da0f2692"
import script from "./OccupazioneBinari.vue?vue&type=script&lang=js"
export * from "./OccupazioneBinari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports